<!-- mock zoom banner -->
<template>
  <div class="mock-zoom-banner">
    <div>
      <h1 v-if="appDetail.mentorResultTimeStr">Starting time：{{appDetail.mentorResultTimeStr}} ({{appDetail.mentorZone|zoneTitleMap}})</h1>
      <p>After the mock interview is completed, please return to MSP to complete the feedback form.</p>
      <div class="mock-zoom-banner-btn"
           v-if="appDetail.mentorZoom">
        <Button class="zlr-btn-primary"
                @click="zoomHandle">Open Zoom</Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mock-zoom-banner',
  props: ['appDetail'],
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {
    zoomHandle () {
      let zoom = this.appDetail.mentorZoom
      window.open(zoom, '_blank ')
    }
  }
}
</script>
<style lang='less' scoped>
</style>
